import React, { useEffect, useState } from 'react';
import Lenis from '@studio-freight/lenis'
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Article from './Article';
import Cover from './Cover';
import Editorial from './Editorial';
import Quote from './Quote';
import Intro from './Intro'
import Video from './Video'

import './App.scss';
gsap.registerPlugin(ScrollTrigger);
gsap.defaults({ease: "none"});

const path = process.env.PUBLIC_URL

function App() {
  const [currentIndex, setCurrentIndex] = useState(null);
  const [moonXY, setMoonXY] = useState([0, 0]);
  const [moonOpacity, setMoonOpacity] = useState(0);
  const [moving, setMoving] = useState(false);
  const [creditShow, setCreditShow] = useState(false)

  const allowCrossOrigin = (img, url) => {
    var image = new Image();
    image.src = url;
    image.onload = function() {
       img.src = url;
    };
 }

  useEffect(() => {
    // const lenis = new Lenis({
    //   duration: 1.2,
    //   easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
    // });
    
    // function raf(time) {
    //   lenis.raf(time);
    //   ScrollTrigger.update();
    //   requestAnimationFrame(raf);
    // }

    // lenis.on('scroll', (e) => {
    //   console.log(e.velocity)
    //   if (e.velocity === 0) {
    //     setMoving(false)
    //   } else {
    //     setMoving(true)
    //   }
    // })
    
    // requestAnimationFrame(raf);
    
    const section_1 = document.getElementById("vertical");
    // let card_items = gsap.utils.toArray(".vertical__item");
    const timeln = gsap.timeline({ paused: true });
    
    // timeln.fromTo(col_left, {y: 0}, {y: '170vh', duration: 1, ease: 'none'}, 0);
    
    ScrollTrigger.create({
      animation: timeln,
      trigger: section_1,
      start: 'top top',
      end: 'bottom center',
      scrub: true,
    });
    
    const section_2 = document.getElementById("horizontal");
    let box_items = gsap.utils.toArray(".horizontal__item");
    let text_items = gsap.utils.toArray(".p-wrap .panel");
    let container = document.getElementsByClassName("mask-wrap")[0];


    ScrollTrigger.matchMedia({
      // desktop
      "(min-width: 769px)": function() {
        gsap.to(box_items, {
          xPercent: -100 * (box_items.length - 1),
          ease: "none",
          scrollTrigger: {
            trigger: section_2,
            pin: true,
            scrub: 3,
            snap: {
              snapTo: 1 / (box_items.length - 1),
              duration: 0.1,
              delay: 0.1,
              ease: "power1.inOut"
            },
            end: "+=" + section_2.offsetWidth,
            onUpdate: self => {
              const index = Math.round(self.progress * (box_items.length - 1))
              setCurrentIndex(index)
              if (Math.abs(self.progress * (box_items.length - 1) - index) < 0.001) {
                setMoonOpacity(0)
              } else {
                setMoonOpacity(1)
              }
            } 
          }
        }); 
        text_items.forEach((text_item, i) => {
          gsap.to(text_item, {
            y: container.clientHeight - 95 - text_item.clientHeight,
            scrollTrigger: {
              trigger: ".scroller",
              // pin: "#quote",
              scrub: true,
              start: "top top",
              end: "bottom bottom+=" + window.innerHeight * 0.3,
              // markers: true
            }
          });
        });
      },
      "(max-width: 768px)": function() {
        text_items.forEach((text_item, i) => {
          gsap.to(text_item, {
            y: container.clientHeight - 50 - text_item.clientHeight,
            scrollTrigger: {
              trigger: ".scroller",
              // pin: "#quote",
              scrub: true,
              start: "top top",
              end: "bottom bottom+=" + window.innerHeight * 0.3,
              // markers: true
            }
          });
        });
      },
    });
    // ScrollTrigger.create({
    //   trigger: "#quote",
    //   pin: true,
    //   start: "top top",
    //   end: "bottom top",
    // });

    ScrollTrigger.create({
      trigger: ".video .container",
      start: "top 10%",
      onLeaveBack: () => {
        setCreditShow(false)
      }
    });

    var remoteImage =  new Image();
    // remoteImage.src = 'https://s3cdn.wainao.me/react-static/special-reports/run/illus01.png';
    allowCrossOrigin(remoteImage, path + '/illus01.png');

  }, []);


  useEffect(() => {
    switch (currentIndex) {
      case 0:
        setMoonXY(['36.5vw', 'calc(100vh - 44.5vw)'])
        break;
      case 1:
        setMoonXY(['78.3vw', '12.2vh'])
        break;
      case 2:
        setMoonXY(['31.3vw', 'calc(100vh - 38.8vw)'])
        break;
      case 3:
        setMoonXY(['86.5vw', 'calc(100vh - 40.8vw)'])
        break;
      case 4:
        setMoonXY(['73.5vw', '14.6vh'])
        break;
      case 5:
        setMoonXY(['12vw', 'calc(100vh - 41vw)'])
        break;
      default:
        setMoonXY(['-6vw', '-6vh'])
    }
  }, [currentIndex]);

  return (
    <div className="App">
      <div className='bg' style={{ backgroundImage: `url(${path}/bg.jpg)`}} />
      <Cover />
      <Intro title="序"/>
      
      <section id="vertical">
        <div className="vertical__content">
          <div className="vertical__item">
            <Quote moving={moving} />
          </div>
          <div className="vertical__item">
            <Editorial
              index={'ver0'}
              currentIndex={currentIndex}
              title="<strong>润</strong>是一场个人对国家的消极反抗，却也暗示了社会运动的新可能"
              subtitle="评论" />
          </div>
        </div>
      </section>
      
      <div className='horizontal__wrapper'>
        <section id="horizontal">
          <div className="horizontal__item">
            <Article
              size="large"
              index={0}
              currentIndex={currentIndex}
              direction="left bottom"
              imgSrc="illus01"
              svgSrc="line01"
              title="没钱也要润，赴日留学生靠打工独立闯前程"
              desc="家中支持的生活费捉襟见肘，林森平时大部分时间只会吃超市99日元的饭团，每天要等到超市夜间打折的时候去买盒饭作为晚餐。晚上在私塾里学到一半，她会偷偷溜出去抢附近平价超市的盒饭，有老师说她不专心学习，她平淡回了四个字：“生活所迫”。"
              link="https://www.wainao.me/wainao-reads/running-as-foreign-students-05012023"
              type="article"
              subtitle="深度报道" />
          </div>
          <div className="horizontal__item">
            <Article
              index={1}
              currentIndex={currentIndex}
              direction="right"
              imgSrc="illus02"
              svgSrc="line02"
              title="从国内优势群体变成国外边缘人，中产新移民自甘“贬值”"
              desc="信息不对称再加上“花钱解决问题”的依赖心理，是很多中产人士的短板，让他们在移民途中面临很多风险。像安迪和莫莉这样，在移民过程中被中介吃钱、耽误了时间，或许只能算中介乱象的冰山一角。还有一些人遇到的是妥妥的骗局，不但移民的目的落空，钱也打了水漂。"
              link="https://www.wainao.me/wainao-reads/run-middle-class-new-immigrants-to-marginalized-foreigner-05012023"
              subtitle="深度报道" />
          </div>
          <div className="horizontal__item">
            <Article
              size="large"
              index={2}
              currentIndex={currentIndex}
              direction="left bottom"
              imgSrc="illus03"
              svgSrc="line03"
              title="娜拉出走之后：那些润到西方的女性，境遇变好了吗？"
              desc="“东亚女性痛苦的一个点就在于家庭。”到西欧之后，肉桂观察到一个现象：身边的女孩子要留下来的意愿非常强烈，但男性反而没那么想留下。“男性在国内处于优势地位，出来之后反而会因为亚裔的身份而感受到自己处于弱势地位，他们会不习惯这种转变。”"
              link="https://www.wainao.me/wainao-reads/women-who-run-05012023"
              subtitle="深度报道" />
          </div>
          <div className="horizontal__item">
            <Article
              index={3}
              currentIndex={currentIndex}
              direction="right bottom"
              imgSrc="illus04"
              svgSrc="line04"
              title="因跨性别而无家可归，我决定去瑞士“跳机”"
              desc="对于跨性别者以翎来说，没有选择、不得不走的情绪大于对外面的向往。因试图纠正自己的性别，她被父母赶出家门。不久后遭遇疫情封控，她的精神急剧恶化。冒险偷渡前，她打电话回家，请求父母带她去医院，得到的回答却是：你千万不要回家。这推了她最后一把。"
              link="https://www.wainao.me/wainao-watches/wainao-watches/runology-china-migrants-transgender-A4revolution"
              type="video"
              subtitle="短片" />
          </div>
          <div className="horizontal__item">
            <Article
              index={4}
              currentIndex={currentIndex}
              direction="right"
              imgSrc="illus05"
              svgSrc="line05"
              title="逃离歧视、压迫和无解的民族矛盾，少数族裔突破重围出国" desc="朋友跟他说维吾尔人要在出入境部门取得护照，看来免不了贿赂。Sawut 花了一万人民币收买相关官员，先取得护照，又两次报团去土耳其及日本旅行，之后再申请到日本读书。“只要是（逃到）民主国家便好了，我不想待在极权国家。”他放弃了铁路公司的厚职，坚决离开新疆。"
              link="https://www.wainao.me/wainao-reads/run-ethnic-minorities-discrimination-oppression-ethnic-oppression-05012023"
              subtitle="深度报道" />
          </div>
          <div className="horizontal__item">
            <Article
              index={5}
              currentIndex={currentIndex}
              direction="left bottom"
              imgSrc="illus06"
              svgSrc="line06"
              title="暗中兴起的 “走线”潮，为谋生他们冒死穿越雨林、偷渡美国" desc="因为担心吓到两个孩子，他决定不告诉他们此行的目的。“孩子以为只是暑假旅行，并不知道要移民到美国去，更不知道要走雨林。”几周后，看着两个孩子穿着湿透的衣服，在雨林中分享最后一块面包，西门感到“愧疚，心疼，但不后悔，”他说，“这个制度下，能用脚投票的中国人都应该离开。”"
              link="https://www.wainao.me/wainao-reads/run-trekking-smuggling-through-borders-05012023"
              subtitle="深度报道" />
          </div>
          <svg style={{transform: `translate(${moonXY[0]}, ${moonXY[1]})`, opacity: moonOpacity}} className='moon' viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_480_20443)">
            <path d="M49.5 99C76.8381 99 99 76.8381 99 49.5C99 22.1619 76.8381 0 49.5 0C22.1619 0 0 22.1619 0 49.5C0 76.8381 22.1619 99 49.5 99Z" fill="url(#paint0_linear_480_20443)" fillOpacity="0.5"/>
            </g>
            <defs>
            <linearGradient id="paint0_linear_480_20443" x1="24.7459" y1="6.62506" x2="74.2541" y2="92.3777" gradientUnits="userSpaceOnUse">
            <stop stopColor="#EBC291" stopOpacity="0.2"/>
            <stop offset="0.07" stopColor="#EAC298" stopOpacity="0.35"/>
            <stop offset="0.17" stopColor="#EAC2A0" stopOpacity="0.52"/>
            <stop offset="0.27" stopColor="#E9C3A7" stopOpacity="0.67"/>
            <stop offset="0.38" stopColor="#E9C3AD" stopOpacity="0.79"/>
            <stop offset="0.5" stopColor="#E9C3B1" stopOpacity="0.88"/>
            <stop offset="0.63" stopColor="#E9C3B4" stopOpacity="0.95"/>
            <stop offset="0.78" stopColor="#E9C3B6" stopOpacity="0.99"/>
            <stop offset="1" stopColor="#E9C4B7"/>
            </linearGradient>
            <clipPath id="clip0_480_20443">
            <rect width="99" height="99" fill="white"/>
            </clipPath>
            </defs>
          </svg>
        </section>
      </div>

      <Video
        title="润出中国的年轻人，梦想照进现实？"
        desc="艺术从业者友详与自己的同性伴侣结婚后，留在了明尼阿波利斯，一边过着“家庭主夫”般的生活，一边重新审视自己和社会。通过“走线”冒死偷渡到美国的Azure，在达拉斯找到了按摩工作，虽辛苦维生但也感到满足。不堪社会与家庭暴力而逃到瑞士的跨性别者以翎，暂居在政府提供的庇护所里，却仍挂心国内的跨性别者权益，不忘为“白纸运动”发声。歪脑带你走进他们润后的生活，听他们回顾、反思自己润的旅程。"
        subtitle="纪录短片"
        creditShow={creditShow}
        setCreditShow={setCreditShow}
      />
    </div>
  );
}

export default App;
